import axios, { AxiosError } from "axios";
import { ApiResponse } from "../../types/BaseModals/ApiResponse";  
import { API_URL } from "../../constants/API_URL";
import { DevamsizlikResponseModal } from "../../types/modals";   
import { DevamsizlikRequestModal } from "../../types/RequestModals/DevamsizlikRequestModal";
import { DevamsizlikError } from "../../types/ErrorModals/DevamsizlikError";

export const getDevamsizlik = async (request: DevamsizlikRequestModal): Promise<DevamsizlikResponseModal[]> => {
  try {
    const response = await axios.post<ApiResponse<DevamsizlikResponseModal[]>>(
      `${API_URL}/api/Devamsizlik/getDevamsizlik`,
      request
    );

    if (!response.data.success) {
      throw new Error(response.data.message);
    }

    return response.data.data!;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;

      if (axiosError.response?.status === 404) {
        throw {
          message: responseData?.message || "Devamsızlık listesi bulunamadı",
          correlationId: responseData?.correlationId
        } as DevamsizlikError;
      }

      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId
        } as DevamsizlikError;
      }

      throw {
        message: responseData?.message || "Bir hata oluştu",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData
      } as DevamsizlikError;
    }

    throw { 
      message: "Beklenmeyen bir hata oluştu"
    } as DevamsizlikError;
  }
};